<template>
    <div>
        <div class="gray_line">
            <div class="gray_inner">
                <div class="item active">Проект</div>
            </div>
        </div>
        <div class="request_content">
            <template v-if="!isLoading">
                <template v-if="project.type === 'fprk'">
                    <RvvbProject
                            :project="project"
                            :current-user-email="currentUserEmail"
                            :is-data-updating="isDataUpdating"
										></RvvbProject>
								</template>
                <template v-else-if="project.type === 'complete'">
                    <CompleteProject
                            :project="project"
                            :current-user-email="currentUserEmail"
                            :is-data-updating="isDataUpdating"
                    ></CompleteProject>
                </template>
								<template v-else>
                    <ProcessProject
                            :project="project"
                            :command="command"
                            :current-user-email="currentUserEmail"
                            :is-data-updating="isDataUpdating"
                    ></ProcessProject>
								</template>

            </template>
            <Spin v-else/>
        </div>
    </div>
</template>

<script setup>
import axios from "axios";
import {ref, computed} from "vue";
import {Spin} from "ant-design-vue";
import {Project } from "@/types/types.js"
import ProcessProject from "@/views/ToExpert/ProcessProject.vue";
import RvvbProject from "@/views/ToExpert/RvvbProject.vue";
import CompleteProject from "@/views/ToExpert/CompleteProject.vue";


/** @type {Project} */
let project = ref({});

let isLoading = ref(false);
let command = ref([]);

let tab = ref(1);
let stars = ref(4);

let isDataUpdating = ref(false);


async function getData() {
  isLoading.value = true;
  await getCommand();
  await getProject();
  isLoading.value = false;
}
getData();

async function getCommand() {
	const response = await axios.get('/project/get_project_command/' + window.projectId);
	command.value = response.data;
}

async function getProject() {
  const response = await axios.get('/api/projects/' + window.projectId);
  project.value = response.data;
}

const currentUserEmail = computed(() => window.currentUserEmail);
const projectId = computed(() => window.projectId);

</script>

<style scoped lang="scss">
.request_content:deep {
  .project_afisha {
    max-width: 320px;

    img {
      border-radius: 12px;
    }
  }




  .base_files {
    .countries_block__title {
      margin-bottom: 15px;
    }
  }
  .opit_block {
    padding: 20px;
    border: 1px solid #ccc;
    margin-bottom: 30px;
    margin-left: 30px;
  }
  .opit_item:not(:last-child) {
    margin-bottom: 20px;
  }
  .opit_item {
    border: 1px solid #ccc;
    padding: 20px;
  }

  .as_favorite {
    display: flex;
    align-items: center;
    margin-right: 20px;

    svg {
      margin-left: 10px;
      cursor: pointer;
    }
  }
	.otlozhit {
		display: flex;
		align-items: center;

    svg {
      margin-left: 10px;
      margin-top: 3px;
      cursor: pointer;
    }
	}

  .files_wrapper {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;

    .button4_white {
      border-width: 2px;
			max-width: 400px;
      margin-bottom: 15px;

      &:not(:last-child) {
        margin-right: 15px;
      }

      &:hover {
        color: #000;
      }
    }
	}
	.left_column_par {
		max-width: 210px;
	}
	.par_title {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: rgba(29, 35, 45, 0.5);
	}
	.par_text {
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #1d232d;
	}
	.right_pargraph__wrapper:not(:last-child) {
    margin-bottom: 20px;
	}
	.command_user_wrapper:not(:last-child) {
    margin-bottom: 20px;
	}
	.your_score_text {
		display: flex;
		align-items: center;
	}
	.your_score_text_inner {
    margin-right: 15px;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    color: #000;
	}
	.stars__wrapper {
    margin-top: 4px;
	}
	.star__wrapper {
    margin-right: 7px;
	}
	.your_score_text_field {
    margin-top: 15px;
    margin-bottom: 15px;
	}
	.your_score_text_footer_col1 {
		display: flex;
		align-items: center;
	}
	.your_score_text_footer_col2 {
		display: flex;
		justify-content: flex-end;
	}
	.score_header__wrapper:not(:first-child) {
    margin-top: 15px;
	}
	.score_header__wrapper textarea {
		height: 100px;
	}
	.criterions__wrapper {
    padding-bottom: 20px;
	}
	.total_score_block {
		display: flex;
		justify-content: space-between;
    padding-top: 20px;
    border-top: 1px solid #D9D9D9;
	}
	.total_score_block_text {
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    color: #000;
	}
	.total_score_block_result {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    text-align: right;
    color: rgba(0, 0, 0, 0.5);
	}
	.score_header_right {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.score_header_right_text {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    color: #000;
	}
	.author_columns_right {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
  .project_tour_text {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
  }
	.total_score_block {
    margin-bottom: 20px;
	}
  .author_box {
		padding: 15px 20px;

		.countries_block__sub a {
      font-weight: 500;
      font-size: 16px;
      line-height: 120%;
      text-decoration: underline;
      text-decoration-skip-ink: none;
      color: #db7f1c;
		}
		.author_columns_right a {
			color: #000;
		}

		.column {
      padding-bottom: 0;
      padding-top: 10px;
    }

	}
	.scores_box {
    padding-bottom: 7px;
    padding-top: 13px;
	}
}

@media (max-width: 1000px) {
  .request_content:deep {
		.author_columns_right {
			justify-content: left;
		}
		.your_score_text {
			display: block;
		}
    .star__wrapper {
      margin-right: 3px;
		}
		.your_score_text_inner {
			display: block;
      margin-bottom: 10px;
		}
		.score_header_right {
			display: block;
		}
		.your_score_text_footer_col2 {
			display: block;
		}
		.button4_white {
      margin-bottom: 10px;
		}
    .tabs_wrapper .tab_item {
			font-size: 14px;
		}
    .tabs_wrapper .tab_item:not(:last-child) {
      margin-right: 10px;
		}
		.tabs_wrapper {
			overflow: scroll;
		}

	}
}
</style>
